import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Maybe } from '@anytag/graphql';
import { Body } from '../components';

export interface HistoryTemplateProps<T> {
  loading?: boolean;
  className?: string;
  emptyText?: ReactNode;
  data?: Maybe<readonly T[]>;
  children: (data: readonly T[]) => ReactNode;
}

export const HistoryTemplate = <T,>({ loading, className, children, data, emptyText }: HistoryTemplateProps<T>) => {
  const { t } = useTranslation();

  return (
    <Body className={className} loading={loading}>
      {data?.length ? (
        children(data)
      ) : (
        <div className="flex h-full min-h-[inherit] items-center justify-center text-base text-black-60">
          {emptyText || t('No history')}
        </div>
      )}
    </Body>
  );
};
